<!--  ******************************************************  -->
<!--  DELETE DIALOG                                           -->
<!--  ******************************************************  -->

<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'COMMON.REMOVE' | translate}} {{entity}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="mat-typography dialogBody">
  <p>{{'COMMON.ARE-U-SURE' | translate}} {{customerTitle}}?</p>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="false">{{'BUTTONS.CANCEL' | translate}}</button>
  <button mat-button class="primaryButton" [mat-dialog-close]="true">{{'BUTTONS.DELETE' | translate}}</button>
</mat-dialog-actions>
